// extracted by mini-css-extract-plugin
export var alignBaseline = "_k-9";
export var alignCenter = "_k-5";
export var alignFlexEnd = "_k-7";
export var alignFlexStart = "_k-6";
export var alignSelfBaseline = "_k-e";
export var alignSelfCenter = "_k-a";
export var alignSelfFlexEnd = "_k-c";
export var alignSelfFlexStart = "_k-b";
export var alignSelfStretch = "_k-d";
export var alignStretch = "_k-8";
export var column = "_k-2";
export var columnReverse = "_k-4";
export var flex = "_k-0";
export var justifyCenter = "_k-f";
export var justifyFlexEnd = "_k-h";
export var justifyFlexStart = "_k-g";
export var justifySpaceAround = "_k-j";
export var justifySpaceBetween = "_k-i";
export var justifySpaceEvenly = "_k-k";
export var row = "_k-1";
export var rowReverse = "_k-3";
export var wrapNowrap = "_k-m";
export var wrapWrap = "_k-l";
export var wrapWrapReverse = "_k-n";